var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserFeedbackLikeActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.25 19.5H7A3.5 3.5 0 0 1 3.5 16v-4A3.5 3.5 0 0 1 7 8.5h.25zM13.856 3.5c1.772 0 2.866 1.933 1.954 3.453L14.884 8.5h1.686c2.476 0 4.169 2.5 3.25 4.8l-1.6 4a3.5 3.5 0 0 1-3.25 2.2H8.75v-11h.01l3.315-4.145a2.28 2.28 0 0 1 1.78-.855"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserFeedbackLikeActive);
export default __webpack_public_path__ + "static/media/user-feedback-like-active.555b57a136d3f0f7265db3f32dec4180.svg";
export { ForwardRef as ReactComponent };